import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ExclusionListItem, GlobalExclusionsAppWebComponentSchema, RpcAction, RpcExclusionListsMethod } from '../types';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';

export class GlobalExclusionsAppBaseDataProvider extends BaseWebComponentDataProvider {
  async getGlobalExclusionsData(companyId): Promise<GlobalExclusionsAppWebComponentSchema> {
    const [companyLists, userLists] = await Promise.all([
      this.defaultExclusionLists(companyId),
      this.getCurrentUserLists(companyId),
    ]);

    return {
      companyLists: companyLists,
      userLists: userLists,
    };
  }

  public async getListInfo(companyId, listId): Promise<any> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        companyId: companyId,
        listId: listId,
      },
      endpoint: RpcAction.EXCLUSION_LISTS,
      method: RpcExclusionListsMethod.GET_LIST_INFO,
    });
  }

  public async defaultExclusionLists(companyId): Promise<Array<ExclusionListItem>> {
    const response = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        companyId: companyId,
      },
      endpoint: RpcAction.EXCLUSION_LISTS,
      method: RpcExclusionListsMethod.GET_COMPANY_LISTS,
    });

    return response.data?.map((item) => {
      return {
        value: item._id,
        label: item.name
      };
    }) ?? [];
  }

  public async getCurrentUserLists(companyId): Promise<Array<ExclusionListItem>> {
    const response = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        companyId: companyId,
      },
      endpoint: RpcAction.EXCLUSION_LISTS,
      method: RpcExclusionListsMethod.GET_CURRENT_USER_LISTS,
    });
    return response.data?.map((item) => {
      return {
        value: item._id,
        label: item.name
      };
    }) ?? [];
  }

}
